import React from 'react';

import ScrollAnimation from 'react-animate-on-scroll';

import LinkButton from '@core/components/linkbutton/LinkButton';
import BrandsSlider from '@core/components/brandsslider/BrandsSlider';
import TrustStats from '@core/components/truststats/TrustStats';
import { COURSE_COUNT } from 'constants/site-stats.const';

import { Profile2User, Shield, Book1, Buildings2 } from 'iconsax-react';

import classes from './Hero.module.scss';



const Hero = () => {
    return (
        <>
            <div className={`container ${classes['wrapper']}`}>
                <div className={`${classes['hero-container']} d-flex flex-column justify-content-center align-items-center`}>
                    <h1>
                        Advance Your <span>Pharma Career</span> with Courses, Credentials, and Career Tools Built for <span>Professionals</span>
                        {/* <div className={classes['pharmuni-name']}>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} >
                                P
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={150}>
                                h
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={300}>
                                a
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={450}>
                                r
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={600}>
                                m
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={750}>
                                u
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={900}>
                                n
                            </ScrollAnimation>
                            <ScrollAnimation animateIn="fadeIn" duration={0.2} delay={1050}>
                                i
                            </ScrollAnimation>
                        </div> */}
                    </h1>

                    <p>
                        Pharmuni is a pharma career growth ecosystem built for professionals who want to strengthen their skills, prove their expertise, and move forward with confidence. Newcomers can also follow structured paths to build their way into pharma. 
                        <br/>Built on the real-world pharma consulting experience of Zamann Pharma Support GmbH (ISO 9001 certified).
                    </p>
                    <div className='d-flex flex-wrap align-items-center justify-content-center gap-2 my-4'>
                        <LinkButton
                            kind='primary-color'
                            to={'/get-started'}
                        >
                            Join for Free
                        </LinkButton>
                        <LinkButton
                            kind='primary-light'
                            to={'/explore'}
                        >
                            Explore {COURSE_COUNT}+ Pharma Courses
                        </LinkButton>
                    </div>
                </div>
                {/* <script async src={'animation.js'}></script> */}
            </div>
            <TrustStats
                items={[
                    { label: 'Trusted by', title: '70,000+ Professionals', icon: <Profile2User size="30" color="#18BBA8" /> },
                    { label: 'Backed by', title: 'ISO 9001 Certification', icon: <Shield size="30" color="#18BBA8" /> },
                    { label: 'Access to', title: `${COURSE_COUNT}+ Expert Courses`, icon: <Book1 size="30" color="#18BBA8" /> },
                    { label: 'Powered by', title: 'Zamann Pharma Support', icon: <Buildings2 size="30" color="#18BBA8" /> }
                ]}
            />
            <div className={classes['brands-section']}>
                <div className='container mt-5'>
                    <h3>Pharma professionals on Pharmuni come from companies such as</h3>
                    <BrandsSlider />
                    <div className={classes['disclaimer']}>
                        Company names reflect the backgrounds of registered users and do not imply affiliation or endorsement.
                    </div>
                </div>
            </div>


        </>
    );
};

export default Hero;